
export type CreateNotification201Status = {
  isRead: boolean;
};
